import React from 'react'
import {
    BrowserRouter as Router,
    Switch
} from 'react-router-dom'
import { Helmet } from 'react-helmet'

import Route from './higherOrder/scrollToTopRoute'
import Navigation from './Navigation'
import Footer from './Footer'
import LandingPage from './pages/Landing'
import SignUpPage from './userManagement/SignUp'
import SignInPage from './userManagement/SignIn'
import PasswordForgetPage from './userManagement/PasswordForget'
import DashboardPage from './pages/Dashboard'
import AccountPage from './pages/Account'
import IntroQuestionsPage from './pages/IntroQuestions'
import IntroQuestionsSuccessPage from './pages/IntroQuestionsSuccess'
import SettingsPage from './pages/Settings'
import NotFoundPage from './pages/NotFound'
import PlantDetailsPage from './pages/PlantDetails'
import PlantListPage from './pages/PlantList'
import DeviceListPage from './pages/DeviceList'
import DeviceDetailsPage from './pages/DeviceDetails'
import ClassifierPage from './pages/Classifier'
import PlantClassificationPage from './pages/PlantClassification'
import ModelDownload from './pages/ModelDownload'
import RedirectController from './pages/RedirectController'
import MailVerification from './pages/MailVerification'
import IntroPage from './pages/IntroPage'
import AddSensorPage from './pages/AddSensor'
import PrivacyPage from './pages/Privacy'
import Impressum from './pages/Impressum'
import CookieBanner from './Global/CookieBanner'
import { ContentContainer } from './StyledComponents/Fillers'

import * as routes from '../constants/routes'

import withAuthentication from './higherOrder/withAuthentication'

const App = () =>
    (
        <Router>
            <div>
                <Helmet>
                    <meta name="description" content="Mit dem FlowerAI Smart Garden Assistent kannst du Pflanzen in deinem Garten bestimmen, die Bodenfeuchtigkeit kontrollieren und deinen Garten vollautomatisch bewässern." />
                </Helmet>
                <CookieBanner />
                <Navigation />

                <ContentContainer className="container">
                    <Switch>
                        <Route exact path={routes.LANDING} component={() => <LandingPage />} />
                        <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
                        <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
                        <Route
                            exact
                            path={routes.PRIVACY_POLICY}
                            component={() => <PrivacyPage />}
                        />
                        <Route exact path={routes.IMPRESSUM} component={() => <Impressum />} />
                        <Route
                            exact
                            path={routes.MAIL_VERIFICATION}
                            component={() => <MailVerification />}
                        />
                        <Route
                            exact
                            path={routes.REDIRECT_CONTROLLER}
                            component={() => <RedirectController />}
                        />
                        <Route exact path={routes.INTRO_PAGE} component={() => <IntroPage />} />
                        <Route
                            exact
                            path={routes.PASSWORD_FORGET}
                            component={() => <PasswordForgetPage />}
                        />
                        <Route exact path={routes.DASHBOARD} component={DashboardPage} />
                        <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
                        <Route
                            exact
                            path={routes.INTRO_QUESTIONS}
                            component={() => <IntroQuestionsPage />}
                        />
                        <Route
                            exact
                            path={routes.INTRO_QUESTIONS_SUCCESS}
                            component={() => <IntroQuestionsSuccessPage />}
                        />
                        <Route
                            exact
                            path={routes.PLANT_CLASSIFICATION}
                            component={() => <PlantClassificationPage />}
                        />
                        <Route
                            exact
                            path={routes.MODEL_DOWNLOAD}
                            component={() => <ModelDownload />}
                        />
                        <Route
                            exact
                            path={routes.CLASSIFIER}
                            component={() => <ClassifierPage />}
                        />
                        <Route exact path={routes.SETTINGS} component={() => <SettingsPage />} />
                        <Route path={routes.PLANT} component={PlantDetailsPage} />
                        <Route exact path={routes.PLANTS} component={PlantListPage} />
                        <Route
                            exact
                            path={routes.SENSOR_ADD}
                            component={AddSensorPage}
                        />
                        <Route
                            exact
                            path={routes.SENSOR_DEVICE}
                            component={props => <DeviceDetailsPage type="sensor" {...props} />}
                        />
                        <Route
                            exact
                            path={routes.VALVE_DEVICE}
                            component={props => <DeviceDetailsPage type="valve" {...props} />}
                        />
                        <Route exact path={routes.DEVICES} component={DeviceListPage} />
                        <Route component={() => <NotFoundPage />} />
                    </Switch>
                </ContentContainer>

                <Footer />
            </div>
        </Router>
    )

export default withAuthentication(App)



// WEBPACK FOOTER //
// ./src/components/App.js